<integration-status
	[service]="service"
	sortField="masterAccountName">
</integration-status>
